'use client';
import cx from 'classnames';
import React, { useState } from 'react';
import { getIconBaseUrl } from '../../utils/assets';
import { Button, Size, Theme } from '../Button';
import styles from './InlineMessaging.module.scss';
export var InlineMessagingTheme;
(function (InlineMessagingTheme) {
    InlineMessagingTheme["SUCCESS_THEME"] = "success";
    InlineMessagingTheme["ERROR_THEME"] = "error";
    InlineMessagingTheme["INFO_THEME"] = "info";
    InlineMessagingTheme["WARNING_THEME"] = "warning";
    InlineMessagingTheme["HELP_THEME"] = "help";
})(InlineMessagingTheme || (InlineMessagingTheme = {}));
const icons = {
    [InlineMessagingTheme.SUCCESS_THEME]: getIconBaseUrl('check-grey.svg'),
    [InlineMessagingTheme.ERROR_THEME]: getIconBaseUrl('close-cricle.svg'),
    [InlineMessagingTheme.INFO_THEME]: getIconBaseUrl('information.svg'),
    [InlineMessagingTheme.WARNING_THEME]: getIconBaseUrl('warning-circle.svg'),
    [InlineMessagingTheme.HELP_THEME]: getIconBaseUrl('questionmark-grey.svg'),
};
const InlineMessaging = ({ title, message, link, dismissible = true, CustomLink, type = InlineMessagingTheme.INFO_THEME, className = '', onDismiss, }) => {
    const [dismissed, setDismissed] = useState(false);
    const handleDismiss = () => {
        onDismiss === null || onDismiss === void 0 ? void 0 : onDismiss();
        setDismissed(true);
    };
    const icon = icons[type] || getIconBaseUrl('information.svg');
    if (dismissed)
        return null;
    return (<div className={`inline-message-container ${className}`}>
      <div className={cx(styles.inlineMessage, {
            [styles.inlineMessage__success]: type === InlineMessagingTheme.SUCCESS_THEME,
            [styles.inlineMessage__error]: type === InlineMessagingTheme.ERROR_THEME,
            [styles.inlineMessage__warning]: type === InlineMessagingTheme.WARNING_THEME,
            [styles.inlineMessage__help]: type === InlineMessagingTheme.HELP_THEME,
            [styles.inlineMessage__nonDismissible]: !dismissible,
        })}>
        <div className={styles.content}>
          <div className={styles.icon}>
            <img className={styles.img} src={icon} alt=''/>
          </div>
          <div className={styles.text}>
            {title && typeof title === 'string' ? (<div className={styles.title}>{title}</div>) : null}
            {title && typeof title === 'object' ? title : null}
            {title && typeof title === 'string' && message && typeof message === 'string' ? (<span>{' - '}</span>) : null}
            {message && typeof message === 'string' ? (<div className={styles.description}>{message}</div>) : null}{' '}
            {message && typeof message === 'object' ? message : null}
            {link ? (CustomLink ? (<CustomLink blank={link === null || link === void 0 ? void 0 : link.openNewWindow} path={link === null || link === void 0 ? void 0 : link.url} className={styles.link}>
                  {link === null || link === void 0 ? void 0 : link.description}
                </CustomLink>) : (<a href={link === null || link === void 0 ? void 0 : link.url} target={(link === null || link === void 0 ? void 0 : link.openNewWindow) ? '_blank' : '_self'} className={styles.link} rel='noreferrer'>
                  {link === null || link === void 0 ? void 0 : link.description}
                </a>)) : null}
          </div>
        </div>
        {dismissible ? (<div className='close'>
            <Button icon={getIconBaseUrl('close.svg')} iconOnly onClick={handleDismiss} scale={Size.LARGE_SIZE} theme={Theme.MONOCHROME_THEME}>
              Close
            </Button>
          </div>) : null}
      </div>
    </div>);
};
export default InlineMessaging;
